import { render, staticRenderFns } from "./WidddiInstagram.vue?vue&type=template&id=3575e54b"
import script from "./WidddiInstagram.vue?vue&type=script&lang=js"
export * from "./WidddiInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports